import React from 'react';
import { useTheme } from '../contexts/ThemeContext.jsx';

/**
 * ThemeToggle component for switching between light and dark modes
 * Can be used with or without theme context
 */
const ThemeToggle = ({ theme: propTheme, onToggle, collapsed }) => {
  let themeContext;
  try {
    themeContext = useTheme();
  } catch (error) {
    // Component is being used outside of ThemeProvider
    themeContext = null;
  }
  
  // Use context if available, otherwise fall back to props
  const theme = propTheme || themeContext?.theme || 'light';
  const handleToggle = onToggle || themeContext?.toggleTheme;

  const handleClick = () => {
    if (handleToggle) {
      if (onToggle) {
        // Legacy prop-based usage
        const newTheme = theme === 'light' ? 'dark' : 'light';
        onToggle(newTheme);
      } else {
        // Context-based usage
        handleToggle();
      }
    }
  };

  return (
    <button
      onClick={handleClick}
      className={`
        w-full flex items-center px-4 py-2 text-sm font-medium rounded-lg transition-colors
        ${theme === 'dark' 
          ? 'text-gray-300 hover:bg-gray-700 hover:text-white' 
          : 'text-gray-700 hover:bg-gray-100 hover:text-gray-900'
        }
      `}
      title={collapsed ? `Switch to ${theme === 'light' ? 'dark' : 'light'} mode` : ''}
      aria-label={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
    >
      <span className="text-lg flex-shrink-0">
        {theme === 'light' ? '🌙' : '☀️'}
      </span>
      {!collapsed && (
        <span className="ml-3">
          {theme === 'light' ? 'Dark Mode' : 'Light Mode'}
        </span>
      )}
    </button>
  );
};

export default ThemeToggle;
